import { Icon } from '@legacy/components/ui-components/Icon';

export const IconLeft = () => <Icon iconName="arrowLeft" size="small" />;
